import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import { IconButton, styled, List, ListItem, Typography } from "@mui/material"
import ConventionMeetingType from "models/convention-api/v1/ConventionMeetingType"
import pluralize from "pluralize"
import React from "react"

interface SelectMeetingTypeProps {
  meetingTypes: ConventionMeetingType[]
  onSelect: (selectedMeetingType: ConventionMeetingType) => void
}

export const SelectMeetingType = (props: SelectMeetingTypeProps) => {
  const { meetingTypes, onSelect } = props

  return (
    <_List>
      {meetingTypes.map((meetingType) => {
        const { name, description, duration_minutes } = meetingType
        return (
          <_ListItem key={meetingType.id}>
            <_ListItemName component="h5">{name}</_ListItemName>
            <_ListItemDuration component="p">
              Meeting Duration: {duration_minutes} {pluralize("min", duration_minutes)}
            </_ListItemDuration>
            <_ListItemDescription component="p">{description}</_ListItemDescription>
            <_ListItemIconButton
              aria-label={`Select ${name}`}
              color="primary"
              onClick={() => onSelect(meetingType)}>
              <ArrowForwardIcon />
            </_ListItemIconButton>
          </_ListItem>
        )
      })}
    </_List>
  )
}

const _List = styled(List)(({ theme }) => ({
  padding: 0,

  overflowY: "auto",
  "&::-webkit-scrollbar": {
    display: "none",
  },

  "& > .MuiListItem-root": {
    padding: "30px 0 30px 0",
  },
  "& > .MuiListItem-root:first-child": {
    paddingTop: 0,
  },
  // Divider
  "& > * + *": {
    borderTop: `1px solid ${theme.palette.gray.main}`,
  },
})) as typeof List

// The why - https://github.com/mui-org/material-ui/issues/26469#issuecomment-854320766
// @ts-expect-error
const _ListItem = styled(ListItem)({
  display: "grid",
  gridGap: 10,
  gridTemplateColumns: "1fr auto",
  gridTemplateAreas: `
    "name icon-button"
    "duration icon-button"
    "description description"
  `,
  alignItems: "flex-start",
}) as typeof ListItem

const _ListItemName = styled(Typography)(({ theme }) => ({
  gridArea: "name",

  ...theme.fonts.raleway700,
  fontSize: 16,
  lineHeight: 1.2,
})) as typeof Typography

const _ListItemDuration = styled(Typography)(({ theme }) => ({
  gridArea: "duration",

  fontSize: 16,
  lineHeight: 1.375,
  color: theme.palette.gray.dark,
})) as typeof Typography

const _ListItemDescription = styled(Typography)({
  gridArea: "description",
  fontSize: 16,
  lineHeight: 1.375,
}) as typeof Typography

const _ListItemIconButton = styled(IconButton)({
  gridArea: "icon-button",
  padding: 0,
}) as unknown as typeof IconButton
